<template>
    <div class="footer">
        <p>Copyright 2007-{{currentYear}}©LaoYaoBa.com™Inc.All rights reserved | 闽ICP备17032949号-2</p>
        <p>闽公网安备 35020502000344号</p>
    </div>
</template>

<script>
export default {
    data(){
        return {
          currentYear: "",
        }
    },
    created(){
        let date = new Date();
        this.currentYear = date.getFullYear();
    }
}
</script>

<style scoped>
.footer{
    width: 100%;
    height: 150px;
    bottom: -100px;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    padding: 19px 0 0 0;
    box-sizing: border-box;
}
.footer p{
    font-size: 12px;
    color: #333;
    line-height: 16px;
}
/* .footer{
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    padding: 19px 0 0 0;
    box-sizing: border-box;
}
.footer p{
    font-size: 12px;
    color: #333;
    line-height: 16px;
} */

</style>


// WEBPACK FOOTER //
// src/components/public/Footer.vue